export default __webpack_public_path__ + "static/media/sab-work.eea9126b.webp";